import { Button, ConfirmationDialog, YellowWarningIcon } from '@repo/atomic-components';
import { CSSProperties } from 'react';

interface DeleteConfirmationDialogProps {
  id: string;
  title: string;
  description?: string;
  /** Label of the accepting button. */
  confirmLabel?: string;
  style?: CSSProperties;
}

/**
 * `title` and `description` can also be passed to `confirmDialog` with the id, for copy that
 * depends on what is being deleted; those win over the props.
 */
export const DeleteConfirmationDialog = ({
  id,
  title,
  description,
  confirmLabel = 'Confirm',
  style,
}: DeleteConfirmationDialogProps) => {
  return (
    <ConfirmationDialog
      id={id}
      style={style ?? { width: '19.6875rem' }}
      className='[&_[data-pc-section="closebuttonicon"]]:text-theme-black [&_[data-pc-section="closebutton"]]:hover:bg-transparent'
      headerClassName="rounded-t-lg bg-theme-white"
      contentClassName="!px-6 rounded-b-lg flex flex-col items-center justify-center bg-theme-white"
    >
      {(params, { accept, reject }) => {
        const shownTitle = typeof params.title === 'string' ? params.title : title;
        const shownDescription = typeof params.description === 'string' ? params.description : description;
        return (
          <div className="w-58.25">
            <div className="mb-3 flex w-full justify-center">
              <YellowWarningIcon />
            </div>
            <div className="mb-4 text-center">
              <p className="text-theme-black mb-2 text-sm font-semibold">{shownTitle}</p>
              {shownDescription && <p className="text-theme-text-grey text-sm font-bold">{shownDescription}</p>}
            </div>
            <div className="mt-10 flex justify-end gap-3">
              <Button
                outlined
                onClick={reject}
                size="small"
                className="!text-theme-black !border-theme-border-grey !bg-theme-white hover:bg-theme-background-grey! flex h-8 min-w-15.75 justify-center"
              >
                Cancel
              </Button>
              <Button
                onClick={accept}
                size="small"
                className="bg-theme-dark-green hover:bg-theme-dark-green text-theme-white flex h-8 min-w-17.75 justify-center px-6 py-2"
              >
                {confirmLabel}
              </Button>
            </div>
          </div>
        );
      }}
    </ConfirmationDialog>
  );
};
